// Single source of truth สำหรับ "หน้าไหนต้อง / ไม่ต้อง LINE login"
// ใช้ร่วมกันระหว่าง plugin (plugins/00.liff.client.ts) และ middleware (middleware/checkpoint.global.ts)
// แก้รายการ path ที่นี่ที่เดียว — ทั้งสองไฟล์ sync กันอัตโนมัติ

// Paths ที่ไม่ต้อง LINE login เลย — ใช้ auth วิธีอื่น (pair code) หรือเป็น public page
// (prefix match — "/desktop" ครอบคลุม /desktop, /desktop/login, /desktop/event ฯลฯ)
export const NO_LINE_AUTH_PATHS = [
  "/desktop",
  "/brand",
  "/event-brand",
  "/sort",
  "/producebook",
  "/upload",
];

// Paths ที่ต้อง LINE login แต่ไม่ต้องผ่าน bootstrap (ยังไม่ต้องมี user record ใน Firestore)
export const FREE_FROM_BOOTSTRAP_PATHS = [
  "/",
  "/invite",
  "/auth/login-mobile",
  "/auth/register",
  "/auth/create-user",
  "/test",
  "/playground",
];

export function matchesPath(list: string[], path: string): boolean {
  return list.some((p) => path === p || path.startsWith(p + "/"));
}
